export const VESSEL_AND_IMO_FILTER_FIELD = "vesselNameFilterField";
export const INSPECTION_DATE_FILTER_FIELD = "inspectionDateFilterField";
export const ISSUED_AT_FILTER_FIELD = "issuedDateFilterField";
